export default __webpack_public_path__ + "static/media/module-two.1b547886.png";